import { DynamicInsightsDataAnswer, IDocument } from '../../../@types/Document';
import { DYNAMIC_INSIGHT_PREPEND_INDICATOR } from '../../../constants/dynamicInsightIndicator';
import { IHighlight } from './types';

export function getDynamicInsightHighlights(documentData: IDocument, selectedInsight) {
    if (!selectedInsight) return [];
    if (!documentData.dynamic_insights) return [];

    const dynamicDataInsightsAnswers: DynamicInsightsDataAnswer[] = [];
    for (const key in documentData.dynamic_insights) {
        documentData.dynamic_insights[key].answers.map((answer: DynamicInsightsDataAnswer) => {
            dynamicDataInsightsAnswers.push(answer);
        });
    }

    const insightKey = selectedInsight.replace(DYNAMIC_INSIGHT_PREPEND_INDICATOR, '');
    const selectedAnswer = dynamicDataInsightsAnswers.find(
        (answer) => answer.attribute === insightKey
    );

    const highlights: IHighlight[] = [];

    selectedAnswer?.bboxes.map((bbox, index) => {
        if (!bbox.length) return;
        const arr: number[] = bbox[0];

        if (arr.length) {
            const left = arr[0];
            const top = arr[1];
            const width = arr[2];
            const height = arr[3];
            highlights.push({
                pageIndex: selectedAnswer.pages[index],
                height,
                left,
                top,
                width,
                text: selectedAnswer.answer,
                isSelected: true,
            });
        }
    });

    return highlights;
}
